import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpUserEvent,
  HttpEvent
} from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { UserService } from "../_services/user.service";
import "rxjs/add/operator/do";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { environment } from '../../environments/environment';


@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private client_id = environment.auth0.clientId;
  private client_secret = environment.auth0.client_secret;
  constructor(private router: Router,
    private userService: UserService) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req.headers.get("No-Auth") == "True") return next.handle(req.clone());

    //if (req.url.replace(environment.API_URL, '') == this.router.url) return next.handle(req.clone());
    // comment for public url 21/01/2020
    // if (localStorage.getItem("userID") == null) {     
    //   this.router.navigateByUrl("/login");
    // }

    if (localStorage.getItem("userToken") != null) {
      
      if (localStorage.getItem("state") && localStorage.getItem("code_verifier")) {
        const token = `${btoa(this.client_id+':'+this.client_secret)}`;
        const clonedreq = req.clone({
          headers: req.headers.set(
            'Authorization',
            `Basic ${token}`
          )
        });
        return next.handle(clonedreq).do(
          succ => { },
          err => {
            // if (err.status === 400){
            //   console.log('check it');
            // } //this.router.navigateByUrl("/login");
          }
        );
      } else {
        const clonedreq = req.clone({
          headers: req.headers.set(
            "Authorization",
            "bearer " + localStorage.getItem("userToken")
          )
        });
        return next.handle(clonedreq).do(
          succ => { },
          err => {
            // if (err.status === 400){
            //   console.log('check it');
            // } //this.router.navigateByUrl("/login");
          }
        );
      }
    } else {
      //this.router.navigateByUrl(this.router.url);
      const domain = window.location.hostname;
      let subDomain = "";
      if (domain.indexOf('.') < 0 ||
        domain.split('.')[0] === 'login' || domain.split('.')[0] === 'liveadmin' || domain.split('.')[0] === 'v3' || domain.split('.')[0] === '192' || domain.split('.')[0] === 'admin' || domain.split('.')[0] === 'www' || domain.split('.')[0] === 'beta' || domain.split('.')[0] === 'staging') {
        subDomain = '';
        this.router.navigateByUrl("/login");
      }
      else {
        subDomain = domain.split('.')[0];
        let urlParts = domain.split('.');
        let baseDomain = urlParts.slice(0).slice(-(urlParts.length === 4 ? 3 : 2)).join('.');
        baseDomain == environment.PublicQuoteBuilder_URL ? this.router.navigate(['/builder']) : this.router.navigate(['/store']);  
      }
    }
  }


}


// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/_guards/auth.interceptor.ts